<template>
  <el-tabs v-model="workflowName" style="width: 90%;margin: auto">
    <el-tab-pane label="审核情况" name="one">
      <tableTemplate
        :table-label="workflowLabel"
        :table-data="property">
      </tableTemplate>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import tableTemplate from './tableTemplate'

export default {
  components: {
    tableTemplate
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    property: Array
  },
  data() {
    return {
      workflowData: [],
      workflowName: 'one',
      workflowLabel: [
        {
          label: '日期',
          prop: 'shsj',
          width: '150',
          aligin: 'center'
        },
        {
          label: '审核节点',
          prop: 'lcName',
          width: '120',
          aligin: 'center'
        },
        {
          label: '审核人',
          prop: 'shr',
          width: '100',
          aligin: 'center'
        },
        {
          label: '审核结果',
          prop: 'auditStatus',
          width: '110',
          aligin: 'center'
        },
        {
          label: '通过金额',
          prop: 'shje',
          width: '120',
          aligin: 'center'
        },
        {
          label: '审核意见',
          prop: 'shyj'
        }
      ]
    }
  },
  created() {

  }
}
</script>

<style scoped>

</style>
